import React from 'react';
import { connect } from 'react-redux';
import Radium from 'radium';
import size from 'lodash/size';
import last from 'lodash/last';
import get from 'lodash/get';
import filter from 'lodash/filter';
import takeRight from 'lodash/takeRight';
import { injectIntl, intlShape } from 'react-intl';
import * as keyboardEventHelpers from 'globals/keyboardEvents';

import * as actions from './actions';
import * as selectors from './selectors';

import ChatFormEnumButton from '../ChatFormEnumButton';
import ChatFormInputEnter from '../ChatFormInputEnter';

import styles from './styles';
import messages from './messages';

class ChatFormTreePicker extends React.PureComponent {
  componentWillMount() {
    const { init } = this.props;

    init();
  }

  handleNodeSelect = id => {
    const { nodeSelect } = this.props;

    nodeSelect(id);
  };

  handleKeyPress = (id, e) => {
    const { nodeSelect } = this.props;

    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();

      nodeSelect(id);
    }
  };

  handleSubmit = () => {
    const { onSubmit, breadcrumbs } = this.props;

    const id = breadcrumbs.map(bc => bc.id).join('.');
    const displayName = get(last(breadcrumbs), 'displayName');

    onSubmit(id, displayName);
  };

  handleLastEnumButtonClick = (id, displayName) => {
    const { onSubmit } = this.props;

    onSubmit(id, displayName);
  };

  renderBreadcrumbHeader = () => {
    const { intl, parent } = this.props;

    if (!parent) {
      return (
        <span key="breadcrumbs" style={styles.breadcrumbWrap}>
          <span>{intl.formatMessage(messages.prompt)}</span>
        </span>
      );
    }

    return (
      <span key="breadcrumbs" style={styles.breadcrumbWrap} className="kustomer-app-reply-input-option-preview">
        <span
          onClick={() => this.handleNodeSelect(null)}
          onKeyPress={e => this.handleKeyPress(null, e)}
          className="treePicker-homeNode"
          tabIndex="0"
        >
          {intl.formatMessage(messages.breadcrumbHome)}
        </span>
        <span style={styles.arrowPlain} />
        {this.renderBreadcrumbs()}
      </span>
    );
  };

  renderBreadcrumbs = () => {
    const { breadcrumbs, intl } = this.props;
    let truncated;

    if (!size(breadcrumbs)) return null;

    if (size(breadcrumbs) > 2) {
      truncated = takeRight(breadcrumbs, 2);
    } else {
      truncated = breadcrumbs;
    }

    return truncated.map((breadcrumb, index, array) => {
      return [
        <span
          key={breadcrumb.id}
          role="button"
          aria-label={intl.formatMessage(messages.aria_label_breadcrumb, { displayName: breadcrumb.displayName })}
          onClick={() => this.handleNodeSelect(breadcrumb.id)}
          onKeyPress={e => this.handleKeyPress(breadcrumb.id, e)}
          tabIndex="0"
          style={styles.breadcrumb}
          title={breadcrumb.displayName}
          className="treePicker-breadcrumb"
        >
          {breadcrumb.displayName}
        </span>,
        index + 1 < size(array) && <span key={`breadcrumb-arrow-${breadcrumb.id}`} style={styles.arrowPlain} />,
      ];
    });
  };

  renderMenu = () => {
    const { tree, parent } = this.props;

    const nodes = parent || tree;
    return (
      <div style={styles.top}>
        {nodes.children &&
          nodes.children.map(data => {
            if (data.deleted) return null;
            const children = get(data, 'children');
            const enabledChildren = filter(children, val => !val.deleted);

            return (
              <ChatFormEnumButton
                onClick={size(enabledChildren) > 0 ? this.handleNodeSelect : this.handleLastEnumButtonClick}
                key={data.id}
                displayName={data.displayName}
                value={data.id}
              />
            );
          })}
      </div>
    );
  };

  renderSubmit = () => {
    const { canSubmit } = this.props;
    return (
      <div style={styles.submit}>
        <ChatFormInputEnter
          disabled={!canSubmit}
          className="enterIcon kustomer-app-reply-input-enter-button"
          onClick={() => this.handleSubmit()}
          tabIndex="0"
        />
      </div>
    );
  };

  render() {
    return (
      <div style={styles.container}>
        {this.renderMenu()}
        <div style={styles.bottom}>
          {this.renderBreadcrumbHeader()}
          {this.renderSubmit()}
        </div>
      </div>
    );
  }
}

ChatFormTreePicker.propTypes = {
  canSubmit: React.PropTypes.bool,
  tree: React.PropTypes.shape({
    children: React.PropTypes.array,
  }),
  parent: React.PropTypes.shape({
    id: React.PropTypes.string,
  }),
  breadcrumbs: React.PropTypes.arrayOf(React.PropTypes.object),
  nodeSelect: React.PropTypes.func.isRequired,
  onSubmit: React.PropTypes.func.isRequired,
  init: React.PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

ChatFormTreePicker.defaultProps = {
  canSubmit: false,
  tree: {},
  breadcrumbs: [],
  parent: null,
};

export const mapStateToProps = (state, props) => {
  const property = get(props, 'property', '');
  const treeContainer = selectors.selectTree(state, property);
  return {
    tree: treeContainer.tree,
    canSubmit: selectors.selectCanSubmit(state),
    breadcrumbs: selectors.selectBreadcrumbs(state),
    parent: selectors.selectParent(state),
  };
};

export const mapDispatchToProps = (dispatch, props) => {
  return {
    init: () => {
      const property = get(props, 'property', '');
      dispatch(actions.initTreePicker(property));
      dispatch(actions.clearTreePicker());
    },
    nodeSelect: (id, cb) => {
      dispatch(actions.handleSelect(id, cb));
    },
  };
};

export const intlChatFormTreePicker = injectIntl(Radium(ChatFormTreePicker), { withRef: true });

export default connect(mapStateToProps, mapDispatchToProps)(intlChatFormTreePicker);
